module.exports = __webpack_public_path__ + "static/media/building_illustration.5dffae17.svg";